
// Données pour la valorisation des métaux non ferreux

export const departments = [
  { code: "12", name: "Aveyron", region: "Occitanie" },
  { code: "31", name: "Haute-Garonne", region: "Occitanie" },
  { code: "81", name: "Tarn", region: "Occitanie" },
  { code: "46", name: "Lot", region: "Occitanie" },
  { code: "82", name: "Tarn-et-Garonne", region: "Occitanie" },
  { code: "34", name: "Hérault", region: "Occitanie" },
  { code: "11", name: "Aude", region: "Occitanie" },
  { code: "15", name: "Cantal", region: "Auvergne-Rhône-Alpes" },
  { code: "63", name: "Puy-de-Dôme", region: "Auvergne-Rhône-Alpes" },
  { code: "48", name: "Lozère", region: "Occitanie" },
  { code: "95", name: "Val-d'Oise", region: "Île-de-France" }
];

export const departmentSEOData: Record<string, { zones: string[] }> = {
  "12": { zones: ["Rodez", "Millau", "Decazeville", "Villefranche-de-Rouergue"] },
  "31": { zones: ["Toulouse", "Muret", "Colomiers"] },
  "81": { zones: ["Albi", "Castres", "Mazamet", "Carmaux"] },
  "46": { zones: ["Cahors", "Figeac", "Gourdon"] },
  "82": { zones: ["Montauban", "Castelsarrasin", "Moissac"] },
  "34": { zones: ["Montpellier", "Béziers", "Sète"] },
  "11": { zones: ["Carcassonne", "Castelnaudary", "Narbonne"] },
  "15": { zones: ["Aurillac", "Saint-Flour", "Mauriac"] },
  "63": { zones: ["Clermont-Ferrand", "Riom", "Thiers"] },
  "48": { zones: ["Mende", "Florac", "Marvejols"] },
  "95": { zones: ["Cergy", "Argenteuil", "Beauchamp", "Sarcelles"] }
};

export const MAJOR_CITIES = [
  { name: "Rodez", deptCode: "12" },
  { name: "Millau", deptCode: "12" },
  { name: "Decazeville", deptCode: "12" },
  { name: "Figeac", deptCode: "46" },
  { name: "Albi", deptCode: "81" },
  { name: "Castres", deptCode: "81" },
  { name: "Mazamet", deptCode: "81" },
  { name: "Carmaux", deptCode: "81" },
  { name: "Beauchamp", deptCode: "95" },
  { name: "Toulouse", deptCode: "31" },
  { name: "Montpellier", deptCode: "34" },
  { name: "Castelnaudary", deptCode: "11" },
  { name: "Aurillac", deptCode: "15" },
  { name: "Clermont-Ferrand", deptCode: "63" },
];

// Mapping des noms de villes vers les URLs
export const getCityUrl = (cityName: string) => {
  const cityUrlMap: Record<string, string> = {
    "Rodez": "/nos-services/achat-metaux/rodez",
    "Millau": "/nos-services/achat-metaux/millau", 
    "Decazeville": "/nos-services/achat-metaux/decazeville",
    "Figeac": "/nos-services/achat-metaux/figeac",
    "Castres": "/nos-services/achat-metaux/castres",
    "Beauchamp": "/nos-services/achat-metaux/beauchamp",
    "Albi": "/nos-services/achat-metaux/albi",
    "Cahors": "/nos-services/achat-metaux/cahors"
  };
  
  return cityUrlMap[cityName] || `/nos-services/achat-metaux/${cityName.toLowerCase().replace(/[^a-z0-9]/g, '-')}`;
};
